module.exports = "/_next/static/images/questions-832bac99f716f11c79c79d949bcfc85a.png";